// Define Reducers for Calendar
import { createReducer } from "../../common/reduxUtil";
import {
  QUEST_ACTION_REQUEST,
  QUEST_CREATE_SUCCESS,
  QUEST_CREATE_FAILURE,
  QUEST_UPDATE_SUCCESS,
  QUEST_UPDATE_FAILURE,
  QUEST_SCREEN_SET,
  QUEST_SCREEN_UPDATE,
  QUEST_LINK_UPDATE,
  QUEST_BY_USER_WIP,
  ACTIVATE_START_A_QUEST,
  DEACTIVATE_START_A_QUEST,
  UPDATE_START_A_QUEST_PAYLOAD,
} from "./types";

const initialState = {
  isQuestCreating: false,
  isQuestCreated: false,
  isStartAQuestActive: false,
  startAQuestPayload: null,
  quest: [],
  questCreateStatusText: "",
  currentScreen: QUEST_SCREEN_SET,
  inviteLinks: [],
  isUserCreatingQuest: false,
  currentQuest: {
    questText: null,
    questTemplate: null,
    isAnonymous: false,
    property: [],
    questId: null,
  },
};

export default createReducer(initialState, {
  [QUEST_BY_USER_WIP]: (state, payload) => {
    return Object.assign({}, state, {
      ...payload,
    });
  },
  [QUEST_ACTION_REQUEST]: (state, payload) => {
    return Object.assign({}, state, {
      isQuestCreating: true,
      isQuestCreated: false,
      questCreateStatusText: "Posting ...",
    });
  },
  [QUEST_CREATE_SUCCESS]: (state, payload) => {
    return Object.assign({}, state, {
      isQuestCreating: false,
      isQuestCreated: true,
      quest: [...state.quest, payload],
      questCreateStatusText: "Quest Posted Successfully",
      currentQuest: {
        ...state.currentQuest,
        questId: payload._id,
      },
    });
  },
  [QUEST_CREATE_FAILURE]: (state, payload) => {
    return Object.assign({}, state, {
      isQuestCreating: false,
      isQuestCreated: false,
      questCreateStatusText: "",
    });
  },
  [QUEST_UPDATE_SUCCESS]: (state, payload) => {
    const filteredQuests =
      state.quest && state.quest.filter((quest) => quest._id !== payload._id);
    return Object.assign({}, state, {
      isQuestCreating: false,
      isQuestCreated: true,
      quest: [...filteredQuests, payload],
      questCreateStatusText: "Quest Posted Successfully",
    });
  },
  [QUEST_UPDATE_FAILURE]: (state, payload) => {
    return Object.assign({}, state, {
      isQuestCreating: false,
      isQuestCreated: false,
      questCreateStatusText: "",
    });
  },
  [QUEST_SCREEN_UPDATE]: (state, payload) => {
    return Object.assign({}, state, {
      currentScreen: payload.currentScreen,
    });
  },
  [QUEST_LINK_UPDATE]: (state, payload) => {
    return Object.assign({}, state, {
      inviteLinks: [...state.inviteLinks, payload],
    });
  },
  [ACTIVATE_START_A_QUEST]: (state, payload) => {
    return Object.assign({}, state, payload);
  },
  [DEACTIVATE_START_A_QUEST]: (state, payload) => {
    return Object.assign({}, state, payload);
  },
  [UPDATE_START_A_QUEST_PAYLOAD]: (state, payload) => {
    return Object.assign({}, state, payload);
  },
});
